import { FC } from 'react'
import styles from 'components/features/rewards/rewardPage/HowRewardsWorks/HowRewardsWorks.styl'


export const HowRewardsWorks: FC = () => {
  return (
    <ol className={ styles.howRewardsWorks }>
      <li>
        <img src='/images/golden-cup.svg' className={ styles.image } />
      </li>
      <li>
        <h4>EARN</h4>
        <p>Link accounts, refer friends, and complete opportunities with golden badges.</p>
      </li>
      <li>
        <h4>INVEST</h4>
        <p>Opt-in and we’ll invest your rewards in crypto when you earn $10 or more. Sell anytime.</p>
      </li>
      <li>
        <h4>REDEEM</h4>
        <p>Redeem your rewards with a free ACH bank transfer when you have $10 or more.</p>
      </li>
    </ol>
  )
}
